import Context from "../../context/Context";
import FieldNames from "../../aiim/datasets/FieldNames";
import OfficePlan from "./OfficePlan";
import * as aiimUtil from "../../aiim/util/aiimUtil";
import * as queryUtil from "./queryUtil";
import * as selectionUtil from "../../aiim/util/selectionUtil";
import * as sourceUtil from "./sourceUtil";

/*
  Transactions

    assignPeopleToArea
    assignPeopleToUnit
    unassignPeople

    assignUnitsToArea
    unassignUnits

    unassignArea

 */

const unitBasedFieldsForPeople = [
  "site_id","site_name",
  "facility_id","facility_name",
  "level_id","level_name","level_number","vertical_order",
  "unit_id","unit_name",
  "section_id","section_name",
  "access_type","use_type",
  "capacity","utilization",
  "area_gross","area_net","area_um",
  "elevation_absolute","elevation_relative",
  "height_absolute","height_relative",
  "name_long","name_subtitle","description"
];
// "image_url","orig_fid",
// "contact_email","contact_extension","contact_name","contact_phone","contact_url",
// "source_name","source_path","source_type","source_method",

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

export function applyGdbVersion(layer,editOptions) {
  if (layer && layer.gdbVersion && editOptions) {
    editOptions.gdbVersion = layer.gdbVersion;
  }
}

export function assignPeopleToArea(peopleFeatureItems,areaItem,areaType) {
  const task = {
    peopleFeatureItems: peopleFeatureItems,
    assignPeopleToArea: {
      areaItem: areaItem,
      areaType: areaType
    }
  };
  return updatePeopleAssignments(task);
}

export function assignPeopleToUnit(peopleFeatureItems,unitFeatureItem) {
  const task = {
    peopleFeatureItems: peopleFeatureItems,
    assignPeopleToUnit: {
      unitFeatureItem: unitFeatureItem
    }
  };
  return updatePeopleAssignments(task);
}

export function assignUnitsToArea(unitFeatureItems,areaItem,areaType) {
  const task = {
    unitFeatureItems: unitFeatureItems,
    assignUnitsToArea: {
      areaItem: areaItem,
      areaType: areaType
    }
  };
  return updateUnitAssignments(task);
}

export function unassignArea(areaItem,areaType) {
  const task = {
    unassignArea: {
      areaItem: areaItem,
      areaType: areaType
    }
  };
  return _unassignArea(task);
}

export function unassignPeople(peopleFeatureItems) {
  const task = {
    peopleFeatureItems: peopleFeatureItems,
    unassignPeople: true
  };
  return updatePeopleAssignments(task);
}

export function unassignUnits(unitFeatureItems) {
  const task = {
    unitFeatureItems: unitFeatureItems,
    unassignUnits: true
  };
  return updateUnitAssignments(task);
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

export function addAttributeEdit(fields,attributes,name,value) {
  const f = aiimUtil.findField(fields,name);
  if (f) attributes[f.name] = value;
}

export function getPeopleSource() {
  return sourceUtil.getPeopleSource();
}

export function getUnitsSource() {
  return sourceUtil.getUnitsSource();
}

export function getPersonAssignmentName(personFeatureItem) {
  //const msg = "Inconsistant space assignment type for person:";
  const attributes = personFeatureItem.feature.attributes;
  //const asnType = aiimUtil.getAttributeValue(attributes,FieldNames.PEOPLE_SPACE_ASSIGNMENT_TYPE);
  const unitId = aiimUtil.getAttributeValue(attributes,FieldNames.UNIT_ID);
  const areaId = aiimUtil.getAttributeValue(attributes,FieldNames.PEOPLE_AREA_ID);
  const hasUnitId = (typeof unitId === "string" && unitId.length > 0);
  const hasAreaId = (typeof areaId === "string" && areaId.length > 0);
  if (hasUnitId) {
    // if (hasAreaId || (asnType !== OfficePlan.SpaceAssignmentTypes.office)) {
    //   //console.warn(msg,personFeatureItem);
    // }
    return aiimUtil.getAttributeValue(attributes,FieldNames.UNIT_NAME);
  } else {
    if (hasAreaId) {
      // if (asnType !== OfficePlan.SpaceAssignmentTypes.hotdesk &&
      //     asnType !== OfficePlan.SpaceAssignmentTypes.hotel) {
      //   console.warn(msg,personFeatureItem);
      // }
      // return OfficePlan.getActive().getAreaName(areaId,asnType);
      return OfficePlan.getActive().getAreaName(areaId);
    } else {
      // if (asnType === OfficePlan.SpaceAssignmentTypes.none) {
      //   return Context.instance.i18n.spaceplanner.people.noAssignment;
      // }
      // if (asnType !== OfficePlan.SpaceAssignmentTypes.none) {
      //   //console.warn(msg,personFeatureItem);
      // }
      return Context.instance.i18n.spaceplanner.people.noAssignment;
    }
  }
}

export function getUnitAssignmentType(unitFeatureItem) {
  const attributes = unitFeatureItem.feature.attributes;
  return aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
}

export function getUnitAssignmentName(unitFeatureItem) {
  // TODO validate the FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE
  const msg = "Inconsistant space assignment type for unit:";
  const attributes = unitFeatureItem.feature.attributes;
  const asnType = aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
  const areaId = aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_AREA_ID);
  const hasAreaId = (typeof areaId === "string" && areaId.length > 0);
  //console.log("asnType",asnType,"hasAreaId",hasAreaId,unitFeatureItem.feature.attributes);
  if (hasAreaId) {
    if (asnType !== OfficePlan.SpaceAssignmentTypes.hotdesk &&
        asnType !== OfficePlan.SpaceAssignmentTypes.hotel) {
      console.warn(msg,unitFeatureItem);
    }
    return OfficePlan.getActive().getAreaName(areaId,asnType);
  } else if (asnType === OfficePlan.SpaceAssignmentTypes.office) {
    // validate that people are actually assigned?
    return Context.instance.i18n.spaceplanner.units.occupied;
  } else if (asnType === OfficePlan.SpaceAssignmentTypes.none) {
    return Context.instance.i18n.spaceplanner.units.unoccupied;
  } else if (asnType === OfficePlan.SpaceAssignmentTypes.notAssignable) {
    return Context.instance.i18n.spaceplanner.units.notAssignable;
  }
}

export function isPersonAssignedToUnit(featureItem) {
  const unitId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.UNIT_ID);
  const hasUnitId = (typeof unitId === "string" && unitId.length > 0);
  return hasUnitId;
}

export function isPersonUnassigned(featureItem) {
  const unitId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.UNIT_ID);
  const areaId = aiimUtil.getAttributeValue(featureItem.feature.attributes,FieldNames.PEOPLE_AREA_ID);
  const hasUnitId = (typeof unitId === "string" && unitId.length > 0);
  const hasAreaId = (typeof areaId === "string" && areaId.length > 0);
  return !(hasUnitId || hasAreaId);
}

export function isUnitUnassigned(featureItem) {
  const attributes = featureItem.feature.attributes;
  const asnType = aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
  const areaId = aiimUtil.getAttributeValue(attributes,FieldNames.UNITS_AREA_ID);
  const hasAreaId = (typeof areaId === "string" && areaId.length > 0);
  return !(hasAreaId || asnType !== OfficePlan.SpaceAssignmentTypes.none);
}

export function makeWhereForPeopleAssignedToArea(areaItem,areaType) {
  const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
  const source = getPeopleSource();
  const layer = source.layer2D;
  const areaIdField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_AREA_ID);
  const v = selectionUtil.escSqlQuote(areaId);
  const where = "("+areaIdField.name+" = '"+v+"')";
  return where;
  // const asnTypeField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_SPACE_ASSIGNMENT_TYPE);
  // let v1 = selectionUtil.escSqlQuote(areaId);
  // v1 = "("+areaIdField.name+" = '"+v1+"')";
  // let v2 = selectionUtil.escSqlQuote(areaType);
  // v2 = "("+asnTypeField.name+" = '"+v2+"')";
  // const where = v1 + " AND " + v2;
  // return where;
}

export function makeWhereForUnitsAssignedToArea(areaItem,areaType) {
  const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
  const source = getUnitsSource();
  const layer = source.layer2D;
  const areaIdField = aiimUtil.findField(layer.fields,FieldNames.UNITS_AREA_ID);
  const asnTypeField = aiimUtil.findField(layer.fields,FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE);
  let v1 = selectionUtil.escSqlQuote(areaId);
  v1 = "("+areaIdField.name+" = '"+v1+"')";
  let v2 = selectionUtil.escSqlQuote(areaType);
  v2 = "("+asnTypeField.name+" = '"+v2+"')";
  const where = v1 + " AND " + v2;
  return where;
}

export function queryPeopleAssignedToArea(areaItem,areaType) {
  const source = getPeopleSource();
  const layer = source.layer2D;
  const orderByField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_FULLNAME);
  const where = makeWhereForPeopleAssignedToArea(areaItem,areaType);
  const options = {
    source: source,
    where: where,
    orderByFields: [orderByField.name]
  };
  return queryUtil.queryFeatures(options).then(result => {
    if (result && result.features) {
      const resultInfo = queryUtil.makeResultInfo(source,result);
      return resultInfo.featureItems;
    } else {
      return [];
    }
  });
}

export function queryPeopleAssignedToUnit(unitFeatureItem) {
  const unitIdField = FieldNames.UNIT_ID;
  const unitId = aiimUtil.getAttributeValue(unitFeatureItem.feature.attributes,unitIdField);
  const source = getPeopleSource();
  const v = selectionUtil.escSqlQuote(unitId);
  const where = "("+unitIdField+" = '"+v+"')";
  const options = {
    source: source,
    where: where,
    orderByFields: [FieldNames.PEOPLE_FULLNAME]
  }
  return queryUtil.queryFeatures(options).then(result => {
    if (result && result.features) {
      const resultInfo = queryUtil.makeResultInfo(source,result);
      return resultInfo.featureItems;
    } else {
      return [];
    }
  });
}

export function queryPeopleNamesAssignedToUnits(unitFeatureItems) {
  let where = "";
  const unitsLayer = sourceUtil.getUnitsSource().layer2D;
  const peopleLayer = sourceUtil.getPeopleSource().layer2D;
  const fldA = aiimUtil.findField(unitsLayer.fields,FieldNames.UNIT_ID);
  const fldB = aiimUtil.findField(peopleLayer.fields,FieldNames.PEOPLE_UNIT_ID);
  const nameFld = aiimUtil.findField(peopleLayer.fields,FieldNames.PEOPLE_FULLNAME);

  const values = [];
  unitFeatureItems.forEach((featureItem,i) => {
    let v = aiimUtil.getAttributeValue(featureItem.feature.attributes,fldA.name);
    v = "'" + selectionUtil.escSqlQuote(v) + "'";
    values.push(v);
  });
  if (values.length > 0) where = fldB.name + " IN (" + values.join(",") + ")";

  // unitFeatureItems.forEach((featureItem,i) => {
  //   let v = aiimUtil.getAttributeValue(featureItem.feature.attributes,fldA.name);
  //   v = "'" + selectionUtil.escSqlQuote(v) + "'";
  //   let part = "("+fldB.name+" = "+v+")";
  //   if (where.length > 0) where += " OR ";
  //   where += part;
  // });

  if (where.length > 0) {
    const options = {
      source: getPeopleSource(),
      where: where,
      orderByFields: [nameFld.name],
      outFields: [nameFld.name]
    }
    return queryUtil.queryFeatures(options).then(result => {
      const names = [];
      if (result && result.features) {
        result.features.forEach(f => {
          let v = aiimUtil.getAttributeValue(f.attributes,nameFld.name);
          names.push(v);
        });
      }
      return {
        names: names,
        exceededTransferLimit: result.exceededTransferLimit
      }
    });
  }
}

export function queryUnitsAssignedToArea(areaItem,areaType) {
  const source = getUnitsSource();
  const layer = source.layer2D;
  const orderByField = aiimUtil.findField(layer.fields,FieldNames.NAME);
  const where = makeWhereForUnitsAssignedToArea(areaItem,areaType);
  const options = {
    source: source,
    where: where,
    orderByFields: [orderByField.name]
  };
  return queryUtil.queryFeatures(options).then(result => {
    if (result && result.features) {
      const resultInfo = queryUtil.makeResultInfo(source,result);
      return resultInfo.featureItems;
    } else {
      return [];
    }
  });
}
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */

export function appendPersonUnassignment(task,peopleFields,peopleUpdate) {
  if (task.isVersioned === undefined) {
    const p = Context.instance.spaceplanner.planner;
    if (p && p.project) {
      task.isVersioned = !!p.project.isVersioned;
    }
  }
  addAttributeEdit(peopleFields,peopleUpdate.attributes,
    FieldNames.PEOPLE_AREA_ID,null);
  // addAttributeEdit(peopleFields,peopleUpdate.attributes,
  //   FieldNames.PEOPLE_SPACE_ASSIGNMENT_TYPE,
  //   OfficePlan.SpaceAssignmentTypes.none);
  unitBasedFieldsForPeople.forEach(f => {
    addAttributeEdit(peopleFields,peopleUpdate.attributes,f,null);
  });
  const pt = new Context.instance.lib.esri.Point({wkid: 4326});
  pt.x = pt.y = null;
  if (task.isVersioned) {
    // TODO?
    pt.x = pt.y = 0; pt.z = 0;
  }
  peopleUpdate.geometry = pt;
}

function appendUnitUnassignment(task,unitFields,unitUpdate) {
  addAttributeEdit(unitFields,unitUpdate.attributes,
    FieldNames.UNITS_AREA_ID,null);
  addAttributeEdit(unitFields,unitUpdate.attributes,
    FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,
    OfficePlan.SpaceAssignmentTypes.none);
}

function arePeopleStillAssigned(task,unitIds,primaryUnitId) {
  if (!unitIds || unitIds.length === 0) return Promise.resolve();
  const promise = new Promise((resolve,reject) => {
    const stillAssigned = [];
    const lib = Context.instance.lib;
    const source = getPeopleSource();
    const layer = source.layer2D;
    const unitIdField = aiimUtil.findField(layer.fields,FieldNames.UNIT_ID);

    const values = [];
    unitIds.forEach(unitId => {
      let v = "'" + selectionUtil.escSqlQuote(unitId) + "'";
      values.push(v);
    });
    let where = unitIdField.name + " IN (" + values.join(",") + ")";
    // let where = "";
    // unitIds.forEach(unitId => {
    //   let v = "'" + selectionUtil.escSqlQuote(unitId) + "'";
    //   let part = "("+unitIdField.name+" = "+v+")";
    //   if (where.length > 0) where += " OR ";
    //   where += part;
    // });
    //console.log("arePeopleStillAssigned====================================",where)
    const url = Context.checkMixedContent(source.url);
    const queryTask = new lib.esri.QueryTask({url: url});
    const query = new lib.esri.Query();
    query.where = where;
    query.outFields = [unitIdField.name];
    query.returnGeometry = false;
    query.returnDistinctValues = true;
    queryUtil.applyGdbVersion(source,query);
    queryTask.execute(query).then(result => {
      if (result && result.features) {
        result.features.forEach(feature => {
          let id = aiimUtil.getAttributeValue(feature.attributes,unitIdField.name);
          if (typeof id === "string" && id.length > 0) {
            if (stillAssigned.indexOf(id) === -1) {
              stillAssigned.push(id);
            }
          }
        });
      }
      task.stillAssignedUnitIds = stillAssigned;
      const unitIdsToFix = [];
      unitIds.forEach(unitId => {
        if (unitId === primaryUnitId || stillAssigned.indexOf(unitId) === -1) {
          unitIdsToFix.push(unitId);
        }
      });
      task.unitIdsToFix = unitIdsToFix;
      resolve();
    }).catch(ex => {
      reject(ex);
    });
  });
  return promise;
}

export function checkUpdateResult(result) {
  const checked = {};
  const updateResults = result && result.updateFeatureResults;
  if (Array.isArray(updateResults)) {
    updateResults.some(ur => {
      if (ur.error) {
        ur.error.submessage = ur.error.message;
        checked.error = ur.error;
        return true;
      }
      return false;
    });
  }
  return checked;
}

function makeUnassignPeopleEdits(task,peopleObjectIds) {
  let edits;
  const source = getPeopleSource();
  const layer = source.layer2D;
  const fields = layer.fields;
  const updates = [];
  if (Array.isArray(peopleObjectIds)) {
    peopleObjectIds.forEach(oid => {
      const update = {attributes: {}};
      update.attributes[layer.objectIdField] = oid;
      appendPersonUnassignment(task,fields,update);
      updates.push(update);
    });
  }
  if (updates.length > 0) edits = {updateFeatures: updates};
  return edits;
}

function makeUnassignUnitEdits(task,unitObjectIds) {
  let edits;
  const source = getUnitsSource();
  const layer = source.layer2D;
  const fields = layer.fields;
  const updates = [];
  if (Array.isArray(unitObjectIds)) {
    unitObjectIds.forEach(oid => {
      const update = {attributes: {}};
      update.attributes[layer.objectIdField] = oid;
      appendUnitUnassignment(task,fields,update);
      updates.push(update);
    });
  }
  if (updates.length > 0) edits = {updateFeatures: updates};
  return edits;
}

function queryObjectIds(source,unitOrAreaIds,areaType) {
  //console.log(unitIdsToFix)
  if (!unitOrAreaIds || unitOrAreaIds.length === 0) return Promise.resolve([]);
  const lib = Context.instance.lib;
  const layer = source.layer2D;
  let idField;
  if (!areaType) {
    idField = aiimUtil.findField(layer.fields,FieldNames.UNIT_ID);
  } else {
    if (source.isAiimPeople()) {
      idField = aiimUtil.findField(layer.fields,FieldNames.PEOPLE_AREA_ID);
    } else if (source.isAiimUnits()) {
      idField = aiimUtil.findField(layer.fields,FieldNames.UNITS_AREA_ID);
    }
  }
  const values = [];
  unitOrAreaIds.forEach(id => {
    let v = "'" + selectionUtil.escSqlQuote(id) + "'";
    values.push(v);
  });
  let where = idField.name + " IN (" + values.join(",") + ")";
  // unitOrAreaIds.forEach(id => {
  //   let v = "'" + selectionUtil.escSqlQuote(id) + "'";
  //   let part = "("+idField.name+" = "+v+")";
  //   if (where.length > 0) where += " OR ";
  //   where += part;
  //   values.push(v);
  // });
  // if (where.length > 0) {
  //   where = "(" + idField.name + " IS NOT NULL) AND (" + where + ")";
  // }
  const url = Context.checkMixedContent(source.url);
  const task = new lib.esri.QueryTask({url: url});
  const query = new lib.esri.Query();
  query.where = where;
  queryUtil.applyGdbVersion(source,query);
  return task.executeForIds(query);
}

function updatePeopleAssignments(task) {
  // task.assignPeopleToUnit task.assignPeopleToArea task.unassignPeople
  const promise = new Promise((resolve,reject) => {
    const peopleUpdates = [];
    const peopleFeatureItems = task.peopleFeatureItems;
    const peopleLayer = getPeopleSource().layer2D;
    const peopleFields = peopleLayer.fields;
    const unitsSource = getUnitsSource();
    const unitsLayer = unitsSource.layer2D;
    const unitBasedFields = unitBasedFieldsForPeople;

    let unitIds = [], primaryUnitOID = null, primaryUnitId = null;
    let unsetUnitBasedFields = false;
    if (task.assignPeopleToUnit) {
      const unitFeatureItem = task.assignPeopleToUnit.unitFeatureItem;
      let unitId = aiimUtil.getAttributeValue(unitFeatureItem.feature.attributes,FieldNames.UNIT_ID);
      if (typeof unitId === "string" && unitId.length > 0) {
        primaryUnitOID = unitFeatureItem.feature.attributes[unitsLayer.objectIdField];
        primaryUnitId = unitId;
        if (unitIds.indexOf(unitId) === -1) unitIds.push(unitId);
      }
    } else {
      unsetUnitBasedFields = true;
    }

    peopleFeatureItems.forEach(peopleFeatureItem => {
      const peopleUpdate = {attributes: {}};
      peopleUpdate.attributes[peopleLayer.objectIdField] = peopleFeatureItem.objectId;

      let unitId = aiimUtil.getAttributeValue(peopleFeatureItem.feature.attributes,FieldNames.UNIT_ID);
      if (typeof unitId === "string" && unitId.length > 0) {
        if (unitIds.indexOf(unitId) === -1) unitIds.push(unitId);
      }

      if (task.assignPeopleToUnit) {
        addAttributeEdit(peopleFields,peopleUpdate.attributes,
          FieldNames.PEOPLE_AREA_ID,null);
        // addAttributeEdit(peopleFields,peopleUpdate.attributes,
        //   FieldNames.PEOPLE_SPACE_ASSIGNMENT_TYPE,
        //   OfficePlan.SpaceAssignmentTypes.office);
        const unitFeatureItem = task.assignPeopleToUnit.unitFeatureItem;
        const unitAttributes = unitFeatureItem.feature.attributes;
        let unitGeometry = unitFeatureItem.geometry || unitFeatureItem.feature.geometry;
        unitBasedFields.forEach(f => {
          let v = aiimUtil.getAttributeValue(unitAttributes,f);
          if (f === "unit_name") v = aiimUtil.getAttributeValue(unitAttributes,"name");
          addAttributeEdit(peopleFields,peopleUpdate.attributes,f,v);
        });
        //console.log("unitGeometry",unitGeometry)
        //console.log("unitFeatureItem",unitFeatureItem)
        if (unitGeometry && typeof unitGeometry.clone !== "function") {
          const g = Context.instance.lib.esri.Graphic.fromJSON({
             attributes: unitAttributes,
             geometry: unitGeometry
          });
          unitGeometry = g.geometry;
        }
        peopleUpdate.geometry = unitGeometry.clone().centroid;
      }

      if (task.assignPeopleToArea) {
        appendPersonUnassignment(task,peopleFields,peopleUpdate);
        const areaItem = task.assignPeopleToArea.areaItem;
        // const areaType = task.assignPeopleToArea.areaType;
        const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
        addAttributeEdit(peopleFields,peopleUpdate.attributes,
          FieldNames.PEOPLE_AREA_ID,areaId);
        // addAttributeEdit(peopleFields,peopleUpdate.attributes,
        //   FieldNames.PEOPLE_SPACE_ASSIGNMENT_TYPE,areaType);
      }

      if (task.unassignPeople) {
        appendPersonUnassignment(task,peopleFields,peopleUpdate);
      }

      peopleUpdates.push(peopleUpdate);
    });
    const peopleEdits = {updateFeatures: peopleUpdates};
    const peopleEditOptions = {};

    let unitEdits;
    const unitEditOptions = {};
    const makeUnitEdits = (unitObjectIds => {
      let unitUpdates = [];
      if (Array.isArray(unitObjectIds)) {
        const unitFields = unitsLayer.fields;
        unitObjectIds.forEach(unitObjectId => {
          const unitUpdate = {attributes: {}};
          unitUpdate.attributes[unitsLayer.objectIdField] = unitObjectId;
          let assignmentType = undefined;
          if (task.assignPeopleToUnit) {
            if (unitObjectId === primaryUnitOID) {
              assignmentType = OfficePlan.SpaceAssignmentTypes.office;
            } else {
              assignmentType = OfficePlan.SpaceAssignmentTypes.none;
            }
          } else if (unsetUnitBasedFields) {
            assignmentType = OfficePlan.SpaceAssignmentTypes.none;
          }
          if (assignmentType !== undefined) {
            addAttributeEdit(unitFields,unitUpdate.attributes,
              FieldNames.UNITS_AREA_ID,null);
            addAttributeEdit(unitFields,unitUpdate.attributes,
              FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,assignmentType);
            unitUpdates.push(unitUpdate);
          }
        });
      }
      if (unitUpdates.length > 0) {
        unitEdits = {updateFeatures: unitUpdates};
      }
    });

    applyGdbVersion(peopleLayer,peopleEditOptions);
    console.log("updatePeopleAssignments.peopleEdits",peopleEdits)
    peopleLayer.applyEdits(peopleEdits,peopleEditOptions).then(result => {
      console.log("updatePeopleAssignments.peopleEdits.result",result)
      const checked = checkUpdateResult(result);
      if (checked && checked.error) {
        // TODO rollback?
        throw checked.error;
      }
    }).then(result => {
      task.unitIdsToFix = unitIds;
      return arePeopleStillAssigned(task,unitIds,primaryUnitId);
      // if (unsetUnitBasedFields) {
      //   return arePeopleStillAssigned(task,unitIds);
      // }
    }).then(result => {
      return queryObjectIds(unitsSource,task.unitIdsToFix);
    }).then(unitObjectIds => {
      console.log("updatePeopleAssignments.unitObjectIds",unitObjectIds)
      makeUnitEdits(unitObjectIds);
    }).then(result => {
      if (unitEdits) {
        applyGdbVersion(unitsLayer,unitEditOptions);
        return unitsLayer.applyEdits(unitEdits,unitEditOptions);
      }
    }).then(result => {
      if (unitEdits) {
        console.log("updatePeopleAssignments.unitEdits.result",result)
        const checked = checkUpdateResult(result);
        if (checked && checked.error) {
          // TODO rollback?
          throw checked.error;
        }
      }
    }).then(result => {
      resolve();
    }).catch(ex => {
      console.error("Error applying edits",ex);
      reject(ex);
    });
  });
  return promise;
}

function updateUnitAssignments(task) {
  const promise = new Promise((resolve,reject) => {
    const unitUpdates = [];
    const unitFeatureItems = task.unitFeatureItems;
    const unitsLayer = getUnitsSource().layer2D;
    const unitFields = unitsLayer.fields;
    const peopleSource = getPeopleSource();
    const peopleLayer = peopleSource.layer2D;
    const unitIdsToFix = [];

    unitFeatureItems.forEach(unitFeatureItem => {
      const unitUpdate = {attributes: {}};
      unitUpdate.attributes[unitsLayer.objectIdField] = unitFeatureItem.objectId;

      // need to fix these unit ids
      const unitId = aiimUtil.getAttributeValue(unitFeatureItem.feature.attributes,FieldNames.UNIT_ID);
      if (typeof unitId === "string" && unitId.length > 0) {
        unitIdsToFix.push(unitId)
      }

      if (task.assignUnitsToArea) {
        // TODO need to fix all the people assigned to this unit
        const areaItem = task.assignUnitsToArea.areaItem;
        const areaType = task.assignUnitsToArea.areaType;
        const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
        addAttributeEdit(unitFields,unitUpdate.attributes,
          FieldNames.UNITS_AREA_ID,areaId);
        addAttributeEdit(unitFields,unitUpdate.attributes,
          FieldNames.UNITS_SPACE_ASSIGNMENT_TYPE,areaType);
      }

      if (task.unassignUnits) {
        appendUnitUnassignment(task,unitFields,unitUpdate);
      }

      unitUpdates.push(unitUpdate);
    });
    const unitEdits = {updateFeatures: unitUpdates};
    const unitEditOptions = {};

    // TODO fix unitIdsToFix (people need to be unassigned from a unit)
    let peopleEdits;
    const peopleEditOptions = {};
    const makePeopleEdits = (peopleObjectIds => {
      if (task.assignUnitsToArea || task.unassignUnits) {
        peopleEdits = makeUnassignPeopleEdits(task,peopleObjectIds)
      }
      // const peopleUpdates = [];
      // if (Array.isArray(peopleObjectIds)) {
      //   if (task.assignUnitsToArea || task.unassignUnits) {
      //     peopleObjectIds.forEach(peopleObjectId => {
      //       const peopleUpdate = {attributes: {}};
      //       peopleUpdate.attributes[peopleLayer.objectIdField] = peopleObjectId;
      //       appendPersonUnassignment(task,peopleFields,peopleUpdate);
      //       peopleUpdates.push(peopleUpdate);
      //     });
      //   }
      // }
      // if (peopleUpdates.length > 0) {
      //   peopleEdits = {updateFeatures: peopleUpdates};
      // }
    });

    // do the people edits first, followed by the unit edits

    // TODO should this query for only people that have space assignment "assigned"
    queryObjectIds(peopleSource,unitIdsToFix).then(peopleObjectIds => {
      console.log("updateUnitAssignments.peopleObjectIds",peopleObjectIds);
      makePeopleEdits(peopleObjectIds);
    }).then(result => {
      if (peopleEdits) {
        applyGdbVersion(peopleLayer,peopleEditOptions);
        return peopleLayer.applyEdits(peopleEdits,peopleEditOptions);
      }
    }).then(result => {
      if (peopleEdits) {
        console.log("updateUnitAssignments.peopleEdits.result",result)
        const checked = checkUpdateResult(result);
        if (checked && checked.error) {
          // TODO rollback?
          throw checked.error;
        }
      }
      applyGdbVersion(unitsLayer,unitEditOptions);
      return unitsLayer.applyEdits(unitEdits,unitEditOptions);
    }).then(result => {
      console.log("updateUnitAssignments.unitEdits.result",result)
      const checked = checkUpdateResult(result);
      if (checked && checked.error) {
        // TODO rollback?
        throw checked.error;
      }
    }).then(result => {
      resolve();
    }).catch(ex => {
      console.error("Error applying edits",ex);
      reject(ex);
    });

  });
  return promise;
}

function _unassignArea(task) {
  const promise = new Promise((resolve,reject) => {
    const areaItem = task.unassignArea.areaItem;
    const areaType = task.unassignArea.areaType;
    const areaId = aiimUtil.getAttributeValue(areaItem.attributes,FieldNames.AREA_ID);
    const areaIds = [areaId];

    const peopleSource = getPeopleSource();
    const peopleLayer = peopleSource.layer2D;
    let peopleEdits;
    const peopleEditOptions = {};

    const unitsSource = getUnitsSource();
    const unitsLayer = unitsSource.layer2D;
    let unitEdits;
    const unitEditOptions = {};

    queryObjectIds(peopleSource,areaIds,areaType).then(peopleObjectIds => {
      peopleEdits = makeUnassignPeopleEdits(task,peopleObjectIds);
      //console.log("_unassignArea.peopleEdits",peopleEdits)
      return queryObjectIds(unitsSource,areaIds,areaType);
    }).then(unitObjectIds => {
      unitEdits = makeUnassignUnitEdits(task,unitObjectIds);
      //console.log("_unassignArea.unitEdits",unitEdits)
    }).then(result => {
      if (peopleEdits) {
        applyGdbVersion(peopleLayer,peopleEditOptions);
        return peopleLayer.applyEdits(peopleEdits,peopleEditOptions);
      }
    }).then(result => {
      if (peopleEdits) {
        console.log("_unassignArea.peopleEdits.result",result)
        const checked = checkUpdateResult(result);
        if (checked && checked.error) {
          // TODO rollback?
          throw checked.error;
        }
      }
    }).then(result => {
      if (unitEdits) {
        applyGdbVersion(unitsLayer,unitEditOptions);
        return unitsLayer.applyEdits(unitEdits,unitEditOptions);
      }
    }).then(result => {
      if (peopleEdits) {
        console.log("_unassignArea.unitEdits.result",result)
        const checked = checkUpdateResult(result);
        if (checked && checked.error) {
          // TODO rollback?
          throw checked.error;
        }
      }
    }).then(result => {
      resolve();
    }).catch(ex => {
      console.error("Error applying edits",ex);
      reject(ex);
    });
  });
  return promise
}

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
